import { projectContext } from '@/layouts/MainLayout'
import { fileListToTree, updateDirectoryOrFile } from '@/services/file/file'
import { Form, Modal, TreeSelect } from 'antd'
import { memo, useContext, useMemo, useState } from 'react'

interface MoveFileProps {
  trigger: JSX.Element
  file: any
  files: any[]
  onSuccess?: Function
}
export default memo<MoveFileProps>(function MoveFile(props) {
  const { trigger, file, files = [], onSuccess } = props
  const { projectId, projectType } = useContext(projectContext)
  const treeData = useMemo(() => fileListToTree(files.filter((item) => !item.file)), [files])
  const [form] = Form.useForm()
  const [isModalVisible, setIsModalVisible] = useState(false)

  const showModal = () => {
    setIsModalVisible(true)
  }

  const handleCancel = () => {
    setIsModalVisible(false)
  }

  return (
    <>
      <span onClick={showModal}>{trigger}</span>
      <Modal
        title={`Move ${file.name} to`}
        visible={isModalVisible}
        maskClosable={false}
        destroyOnClose={true}
        onOk={() => form.submit()}
        onCancel={handleCancel}
      >
        <Form
          form={form}
          onFinish={async (values) => {
            await updateDirectoryOrFile(values, { projectId, projectType, id: file.id })
            setIsModalVisible(false)
            onSuccess?.()
          }}
        >
          <Form.Item name='dirId'>
            <TreeSelect
              showSearch
              dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
              placeholder='Please select'
              allowClear
              treeDefaultExpandAll
              treeData={treeData}
              fieldNames={{ label: 'name', value: 'id' }}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
})
